import ObjectMap from "./ObjectMap";

export default class ControllerApi {

    static post(componentName, data = null) {

        if (data && !data instanceof FormData) {
            data = ObjectMap.objectToFormData(data);
        }

        let formData = data;

        let requestParams = {
            mode: 'class',
            sessid: BX.bitrix_sessid(),
            method: 'POST',
        };

        if (formData) {
            requestParams.data = formData;
        }

        return BX.ajax.runComponentAction(
            componentName,
            'execute',
            requestParams
        );
    }
}

window.ControllerApi = ControllerApi;